/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

/**
 * * `DOCUMENT` - 문서
 * `FOOD` - 음식
 */
export type DeliveryTypeEnum = (typeof DeliveryTypeEnum)[keyof typeof DeliveryTypeEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveryTypeEnum = {
  DOCUMENT: 'DOCUMENT',
  FOOD: 'FOOD'
} as const
